import { Component, Input } from "@angular/core";
import { CustomMessage } from "../../model/custom-message.model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { StatusConfigService } from "../../services/status-config.service";
import { ToastService } from "src/app/shared/toasts/toast-service";

@Component({
  selector: "app-custom-message-form",
  templateUrl: "./custom-message-form.component.html",
  styleUrl: "./custom-message-form.component.scss",
})
export class CustomMessageFormComponent {
  @Input() customMessage: CustomMessage | null = null;
  customMessageForm!: FormGroup;
  loading = false;
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private statusConfigService: StatusConfigService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.customMessageForm = this.fb.group({
      id: [this.customMessage?.id],
      titulo: [this.customMessage?.titulo, Validators.required],
      mensagem: [this.customMessage?.mensagem, Validators.required],
    });
  }

  onSubmit(): void {
    if (this.customMessageForm.invalid) {
      return;
    }
    this.loading = true;
    if (this.customMessage) {
      this.statusConfigService
        .editCustomMessage(this.customMessage.id, this.customMessageForm.value)
        .subscribe({
          next: () => {
            // this.toastService.show("Mensagem atualizado com sucesso", {
            //   classname: "bg-success text-light",
            // });
            this.activeModal.close();
          },
          error: () => {
            this.toastService.show("Erro ao atualizar status", {
              classname: "bg-danger text-light",
            });
          },
          complete: () => {
            this.loading = false;
          },
        });
    } else {
      ("onsubmit");
      this.statusConfigService
        .createCustomMessage(this.customMessageForm.value)
        .subscribe({
          next: () => {
            // this.toastService.show("Status criado com sucesso", {
            //   classname: "bg-success text-light",
            // });
            this.activeModal.close();
          },
          error: () => {
            this.toastService.show("Erro ao criar status", {
              classname: "bg-danger text-light",
            });
          },
          complete: () => {
            this.loading = false;
          },
        });
    }
  }
}
